export let emailButtonLabel = "gaL_xc";
export default {emailButtonLabel};